import styled from "styled-components";

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
`;

export const Label = styled.label`
  color: #212121;
  font-size: 1.6rem;
  margin: 0 0 0.8rem 0;
`;

export const Input = styled.input`
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 3px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
  color: #212121;
  font-size: 1.6rem;
  outline-color: #ffc813;
  padding: 0.8rem 0.8rem 0.8rem 1.6rem;
  width: 100%;
`;

export const Button = styled.button`
  background-color: #ffc813;
  border: none;
  border-radius: 3px;
  color: #000;
  cursor: pointer;
  font-size: 1.4rem;
  font-weight: 600;
  height: 4.8rem;
  line-height: 136%;
  margin: 1.6rem 0 0 0;
  outline-color: #ffc813;
  padding: 0.8rem 1.6rem;
  text-align: center;
  text-transform: uppercase;
  width: fit-content;
`;
